'use strict';

module.exports = {
    createPDPCarousel: function ($productContainer, activeIndex = 0) {
        var slickMainCarousel = $productContainer.find('.js-product-main-carousel');
        var slickThumbnailsMainCarousel = $productContainer.find('.js-slider-nav-thumbnails');

        if (window.innerWidth < 992) {
            // mobile
            if ($(slickMainCarousel).hasClass('slick-initialized')) {
                $(slickMainCarousel).slick('unslick');
            }

            $(slickMainCarousel).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: false,
                dots: true,
                infinite: false
            });
        } else {
            // desktop
            if ($(slickMainCarousel).hasClass('slick-initialized')) {
                $(slickMainCarousel).slick('unslick');
            }

            if ($(slickThumbnailsMainCarousel).hasClass('slick-initialized')) {
                $(slickThumbnailsMainCarousel).slick('unslick');
            }

            $(slickMainCarousel).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                infinite: true,
                speed: 10,
                cssEase: 'linear',
                dots: true,
                asNavFor: '.slider-nav-thumbnails',
                initialSlide: activeIndex
            });

            $(slickThumbnailsMainCarousel).slick({
                autoplay: false,
                slidesToShow: 6,
                slidesToScroll: 1,
                asNavFor: slickMainCarousel,
                arrows: false,
                dots: false,
                centerMode: false,
                focusOnSelect: true,
                variableWidth: false,
                vertical: true
            });
        }
    }
};
